var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M16 1a1 1 0 1 0 0 2h3.586l-5.793 5.793a1 1 0 0 0 1.414 1.414L21 4.414V8a1 1 0 1 0 2 0V2a1 1 0 0 0-1-1h-6zM3 16a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H4.414l5.793-5.793a1 1 0 0 0-1.414-1.414L3 19.586V16z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }